import { Icon } from '@hologram-dimension/icon';
import { Panel } from '@hologram-dimension/panel';
import { PanelNotification } from '@hologram-dimension/panel-notification';
import { PAGE_VIEW } from 'common-js/analytics/actionTypes';
import { sendAnalyticsEvent } from 'common-js/analytics/analytics';
import { ActivePlanList } from 'common-js/components';
import { useAppDispatch, useAppSelector } from 'common-js/hooks';
import { getPlans } from 'common-js/reducers/account/actions';
import {
  getAllBilling,
  getOrgGroups,
  getPlanDeviceSummary,
} from 'common-js/reducers/organization/actions';
import { getAllPoolInfo, getPoolPlans, getPools } from 'common-js/reducers/pools/actions';
import { type FC, type ReactNode, useEffect, useState } from 'react';

const DataPlans: FC = () => {
  const [poolDataLoading, setPoolDataLoading] = useState(true);
  const [planDataLoading, setPlanDataLoading] = useState(true);

  const devicePlanSummary = useAppSelector((state) => state.organization.devicePlanSummary);

  const dispatch = useAppDispatch();

  useEffect(() => {
    sendAnalyticsEvent({
      type: PAGE_VIEW,
      data: { page: 'Sims - Plans' },
    });
  }, []);

  useEffect(() => {
    const load = async () => {
      const planPromises = [dispatch(getPlans()), dispatch(getPlanDeviceSummary())];

      const poolPromises = [
        dispatch(getPoolPlans()),
        dispatch(getOrgGroups()),
        dispatch(getAllBilling()),
        dispatch(getPools()).then((pools) => {
          if (pools.length > 0) {
            dispatch(getAllPoolInfo(pools[0].id)).then(() => {
              Promise.resolve();
            });
          } else {
            Promise.resolve();
          }
        }),
      ];

      Promise.all(poolPromises).finally(() => {
        setPoolDataLoading(false);
      });

      Promise.all(planPromises).finally(() => {
        setPlanDataLoading(false);
      });
    };
    load();
  }, [dispatch]);

  let content: ReactNode;
  if (devicePlanSummary.length > 0) {
    content = <ActivePlanList />;
  } else if (planDataLoading || poolDataLoading) {
    content = <PanelNotification>Loading...</PanelNotification>;
  } else {
    content = (
      <PanelNotification
        label="No plan data"
        icon={<Icon name="Chart" size="large" fill="DdsColorIconDisabled" />}
      >
        After activating a SIM, data plans for your active SIMs will show here.
      </PanelNotification>
    );
  }

  return (
    <Panel
      className="ActivePlanList__panel"
      header="Active data plans"
      noContentPadding
      isLoading={planDataLoading || poolDataLoading}
    >
      {content}
    </Panel>
  );
};

export default DataPlans;
